import { render, staticRenderFns } from "./assist-visit-team-collection.vue?vue&type=template&id=792a16a4"
import script from "./assist-visit-team-collection.vue?vue&type=script&lang=ts"
export * from "./assist-visit-team-collection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports